import React, { memo } from "react";
import { withRedux, WithReduxHocPropsType } from "@al/next/al-ex";

import Loading from "~/components/ui/Loading";

interface Props extends WithReduxHocPropsType {
  loading: boolean;
}

const HomeLoading: React.FC<Props> = (props) => {
  return <Loading mask={true} visible={props.loading} />;
};

export default withRedux((state) => ({ loading: state.static.pageLoading }))(memo(HomeLoading));
